export type VatRateValue = number | string | null | undefined;

export function normalizeVatRate(value: VatRateValue): string {
  if (value === null || value === undefined) {
    return "";
  }

  return String(value).trim();
}

export function formatVatRate(
  value: VatRateValue,
  vatProdPostingGroup?: string | null
): string {
  const normalizedPostingGroup = normalizeVatRate(
    vatProdPostingGroup
  ).toUpperCase();

  if (
    normalizedPostingGroup === "VAT NP." ||
    normalizedPostingGroup === "VAT NP"
  ) {
    return "NP";
  }

  const normalizedValue = normalizeVatRate(value);

  if (normalizedValue === "") {
    return "—";
  }

  const numericValue = Number(normalizedValue.replace(",", "."));
  const isNumericRate =
    /^[-+]?\d+(?:[.,]\d+)?$/.test(normalizedValue) &&
    Number.isFinite(numericValue);

  return isNumericRate ? `${normalizedValue}%` : normalizedValue;
}
